module.exports = __webpack_public_path__ + "images/stickers/pete-broken@2x.6d84909328bf960bdfca.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-broken@2x.png
// module id = Z5Xd
// module chunks = 0